import { Body, useSizeContext } from '@velinsi/smp-widgets-ui';
import { INormalizedStandingsGroup } from '../../../../../packages/types';
import { INormalizedTeamSquadGridItem } from '../../types';
import TeamSquadGridView from './TeamSquadGridView';
import useResizeObserver from '../../../../../packages/hooks/useResizeObserver';
import { TeamSquadViewEnums } from '../../widgets';
import { MAX_MOBILE_WIDTH } from '../../../../../packages/constants/generic';
import { TableVariants } from '../../../../../packages/constants/sportType';

interface ITeamSquadViewProps {
  items: {
    keepers: { name: string; data: INormalizedStandingsGroup[] | INormalizedTeamSquadGridItem[] };
    defenders: { name: string; data: INormalizedStandingsGroup[] | INormalizedTeamSquadGridItem[] };
    midfielders: { name: string; data: INormalizedStandingsGroup[] | INormalizedTeamSquadGridItem[] };
    forwards: { name: string; data: INormalizedStandingsGroup[] | INormalizedTeamSquadGridItem[] };
  };
  handleClick: (id: string | number, name: string) => void;
  view?: string;
  dataImageDisplay?: boolean;
}

function TeamSquadView({ items, handleClick, view, dataImageDisplay }: ITeamSquadViewProps): JSX.Element {
  const { setIsMobile } = useSizeContext();
  const measuredRefTabular = useResizeObserver((fieldElement) => setIsMobile(fieldElement.offsetWidth < MAX_MOBILE_WIDTH));
  return (
    <>
      {view === TeamSquadViewEnums.LIST ? (
        <>
          <Body
            data={items?.keepers?.data as INormalizedStandingsGroup[]}
            handleClick={handleClick}
            isTeamSquad={true}
            measuredRef={measuredRefTabular}
            displayImage={dataImageDisplay}
            tableVariant={TableVariants.STATS}
          />
          <Body
            data={items?.defenders?.data as INormalizedStandingsGroup[]}
            handleClick={handleClick}
            isTeamSquad={true}
            measuredRef={measuredRefTabular}
            displayImage={dataImageDisplay}
            tableVariant={TableVariants.STATS}
          />
          <Body
            data={items?.midfielders?.data as INormalizedStandingsGroup[]}
            handleClick={handleClick}
            isTeamSquad={true}
            measuredRef={measuredRefTabular}
            displayImage={dataImageDisplay}
            tableVariant={TableVariants.STATS}
          />
          <Body
            data={items?.forwards?.data as INormalizedStandingsGroup[]}
            handleClick={handleClick}
            isTeamSquad={true}
            measuredRef={measuredRefTabular}
            displayImage={dataImageDisplay}
            tableVariant={TableVariants.STATS}
          />
        </>
      ) : (
        <>
          <TeamSquadGridView
            items={items?.keepers as { name: string; data: INormalizedTeamSquadGridItem[] }}
            handleClick={handleClick}
            measuredRef={measuredRefTabular}
          />
          <TeamSquadGridView
            items={items?.defenders as { name: string; data: INormalizedTeamSquadGridItem[] }}
            handleClick={handleClick}
            measuredRef={measuredRefTabular}
          />
          <TeamSquadGridView
            items={items?.midfielders as { name: string; data: INormalizedTeamSquadGridItem[] }}
            handleClick={handleClick}
            measuredRef={measuredRefTabular}
          />
          <TeamSquadGridView
            items={items?.forwards as { name: string; data: INormalizedTeamSquadGridItem[] }}
            handleClick={handleClick}
            measuredRef={measuredRefTabular}
          />
        </>
      )}
    </>
  );
}

export default TeamSquadView;
